import {Kurv} from '../../models';
import {renderReadonlyCheckboxCell} from '../../app/helpers/columnHelper';
import {GridColDef, GridValueGetterParams} from '@mui/x-data-grid-pro';
import {useTranslation} from 'react-i18next';
import {KurvLight} from '../../models';
import {Kurvtyper} from '../../models/Constants/Kurvtyper';


export function useKurvColumns({treeView}: { treeView: boolean }) {
    const {t} = useTranslation();
    const columns: GridColDef[] = [
        {field: 'tittel', headerName: t('Navn'), width: 300,},
    ];
    if (!treeView) {
        columns.push({
            field: 'parentKurv',
            headerName: t('Underkurv av'),
            width: 200,
            sortable: false,
            valueGetter: (p) => (p.row['parentKurv'] as KurvLight[])[0]?.tittel,
        });
    }
    columns.push({field: 'beskrivelse', headerName: t('Beskrivelse'), width: 700});
    if (!treeView) {
        columns.push({
            field: 'tab',
            headerName: t('Type kurv'),
            width: 200,
            valueGetter: (p) => Kurvtyper.find(i => i.id === (p.row['tab']))?.navn
        });
        columns.push({field: 'id', headerName: t('Kode'), width: 200, hide: true,});
    }
    if (treeView) {
        columns.push({field: 'id', headerName: t('Kode'), width: 200, hide: true,});
        columns.push({
            field: 'tab',
            headerName: t('Type kurv'),
            width: 200,
            valueGetter: (p) => Kurvtyper.find(i => i.id === (p.row['tab']))?.navn
        });
    }

    columns.push(...[
        {field: 'unique', headerName: t('Id'), hide: true, width: 200},
        {field: 'predef', headerName: t('Predefinert kurv'), width: 200, hide: true},
        {field: 'maksAnt', headerName: t('Maks ant elementer'), width: 200, hide: true}
    ]);

    if (!treeView) {
        columns.push({
            field: 'underKurver', headerName: t('Underkurver'), width: 400, hide: true, sortable: false,
            valueGetter: (p) => (p.row['underKurver'] as KurvLight[]).map(i => i?.tittel).join(', ')
        });
    }

    columns.push({
        field: 'erDistribuertTilHeleOrg',
        headerName: t('Distribuert til hele organisasjonen'),
        width: 200,
        hide: true, sortable: false,
        cellClassName: 'checkbox--cell',
        renderCell: renderReadonlyCheckboxCell

    });

    if (treeView) {
        columns.push(...[
            {
                field: 'parentKurv',
                headerName: t('Underkurv av'),
                width: 200,
                sortable: true,
                hide: true,
                valueGetter: (p: GridValueGetterParams) => (p.row['parentKurv'] as KurvLight[])[0]?.tittel,
            },
            {
                field: 'underKurver', headerName: t('Underkurver'), width: 400, hide: true, sortable: true,
                valueGetter: (p) => (p.row['underKurver'] as KurvLight[]).map(i => i?.tittel).join(', ')
            } as GridColDef
        ]);
    }

    columns.push(...[
        {
            field: 'visDokumenter',
            headerName: t('Vis dokumenter'),
            width: 200,
            hide: true,
            cellClassName: 'checkbox--cell',
            renderCell: renderReadonlyCheckboxCell

        },
        {
            field: 'sperret',
            headerName: t('Stengt for bruk'),
            width: 200,
            hide: true,
            cellClassName: 'checkbox--cell',
            renderCell: renderReadonlyCheckboxCell

        },
        {
            field: 'ValgbareOppfriskningsIntervaller',
            headerName: t('Oppfr intervall'),
            width: 200,
            hide: true,
        },
        {
            field: 'innhold',
            headerName: t('Innhold'),
            width: 200,
            hide: true,
        },
    ]);

    return columns;
}

export function GetAllParentKurver(allKurver: Kurv[], currentKurv: Kurv, parent: Kurv[]): Kurv[] {
    parent = [...parent, currentKurv];
    const childrenForCurrentKurv = GetParent(currentKurv);
    childrenForCurrentKurv?.forEach(lk => {
        const wholeKurv = allKurver.find(whk => whk.id === lk.id);
        if (wholeKurv)
            parent = GetAllParentKurver(allKurver, wholeKurv, parent);
    });
    return parent;
}

function GetParent(kurv: Kurv): Kurv[] {
    return kurv?.parentKurv as Kurv[];
}
